module.exports = __webpack_public_path__ + "static/kiosk_hero-3adf3cb441192f666084b44ecc537335.jpg";